import { takeRight } from "lodash";
import {isMobilePhone, isNumeric} from 'validator';

export const validExpiryDate = (expiryDate) => {
    const expiryMonth = expiryDate?.split('/')[0] || null;
    const expiryYear = expiryDate?.split('/')[1] || null;

    const today = new Date();
    const toYear = Number(
        takeRight(today.getFullYear().toString(), 2).join(''),
    );

    const isValidExpiryDate =
        expiryDate &&
        (Number(expiryMonth) <= 12 || Number(expiryMonth) > 0) &&
        (Number(expiryYear) === toYear
            ? Number(expiryMonth) >= today.getMonth() + 1
            : true) &&
        Number(expiryYear) >= toYear;
    return isValidExpiryDate;
};

export const validACN = (acn) => {
    return (acn?.length || 0) === 9 && isNumeric(acn, {no_symbols: true});
};

export const validABN = (abn) => {
    return (abn?.length || 0) === 11 && isNumeric(abn, {no_symbols: true});
};

export const validRate = (rate) =>{
    const reg = /^\+?(\d*\.\d{2})$/;
    return reg.test(rate)
}

export const validMostTwoDecimalPlaces = (rate)  =>{
    const reg = /^([0]|([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
    return reg.test(rate)
}

export const verifyIfItIsANumber = (str) =>{
    const reg = /^[0-9]+.?[0-9]*$/;
    return reg.test(str)
}

export const verifyIfItIsInteger = (str) =>{
    const reg = /^[0-9]*$/;
    return reg.test(str)
};

export const verifyIfItIsLetter = (str) =>{
    const reg = /^[A-Za-z]+$/;
    return reg.test(str)
}

export const customizeIsMobilePhone = (value) => {
    // return (
    //     isMobilePhone(value, 'any', {strictMode: true}) ||
    //     /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(value)
    // );
    return (
        isMobilePhone(value, 'any', {strictMode: true}) ||
        /^[+]?[(]?[0-9]{3}[)]?[-\s]?[0-9]{3}[-\s]?[0-9]{4,6}$/.test(value)
    );
}

export const validateChineseId = (value) => {
    if (!value) return false;
    // 中国二代身份证正则（完整校验）
    const idCardRegex =
        /^[1-9]\d{5}(18|19|20|21|22)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;

    return idCardRegex.test(value);
};

export const validateName = (value) => {
    if (!value) return true;

    // 长度限制
    if (value.length > 50) {
        return false;
    }

    // 不能以数字开头
    if (/^\d/.test(value)) {
        return false;
    }

    // 允许中文、英文、数字、空格
    // 不允许特殊字符
    if (!/^[a-zA-Z0-9\u4e00-\u9fa5 ]+$/.test(value)) {
        return false;
    }
    return true;
};


export const validateInput = (value) => {
    if (!value) return true;
    // 允许中文、英文、数字、空格
    // 不允许特殊字符
    if (!/^[a-zA-Z0-9\u4e00-\u9fa5 ]+$/.test(value)) {
        return false;
    }
    return true;
};
